import { BaseService } from './BaseService';
import { FetchResult } from 'apollo-link';
import { ApolloQueryResult } from 'apollo-client';
import fetchContactsQuery from '@/graphql/queries/FetchContact.gql';
import createContact from '@/graphql/mutations/ContactCreate.gql';
import updateContactQuery from '@/graphql/mutations/ContactUpdate.gql';
import deleteContact from '@/graphql/mutations/ContactDelete.gql';
import {
  ContactFields,
  ContactInput,
  PaginationInput,
  fetchContacts,
  ContactScopedInput,
  updateContact
} from '@/types/graphql/schemaTypes';

class ContactService extends BaseService {
  public fetchContacts(
    contactArgs?: ContactScopedInput | null,
    pagination?: PaginationInput | null):
  Promise<ApolloQueryResult<fetchContacts>> {
    return this.client.query({
      query: fetchContactsQuery,
      variables: {
        pagination,
        contactArgs: contactArgs || {}
      }
    });
  }

  public createContact(contactArgs: ContactInput):
  Promise<FetchResult<ContactFields>> {
    return this.client.mutate({
      mutation: createContact,
      variables: {
        contactArgs
      }
    });
  }

  public updateContact(contactArgs: ContactInput):
  Promise<FetchResult<updateContact>> {
    return this.client.mutate({
      mutation: updateContactQuery,
      variables: {
        contactArgs
      }
    });
  }

  public deleteContact(contactArgs: ContactInput):
  Promise<FetchResult<boolean>> {
    return this.client.mutate({
      mutation: deleteContact,
      variables: {
        contactArgs
      }
    });
  }
}

export const contactService = new ContactService();
